import { useDisclosure } from '@phx/design-system/hooks';
import {
    type PropsWithChildren as PWC,
    createContext,
    useContext,
} from 'react';

export type SidebarCtx = {
    close: () => void;
    isOpen: boolean;
    open: () => void;
    toggle: () => void;
};

const SidebarContext = createContext<SidebarCtx | null>(null);

export const SidebarProvider = ({ children }: PWC) => {
    const [isOpen, { open, close, toggle }] = useDisclosure();

    const ctx: SidebarCtx = {
        close,
        isOpen,
        open,
        toggle,
    };

    return (
        <SidebarContext.Provider value={ctx}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebarContext = () => {
    const ctx = useContext(SidebarContext);
    if (ctx === null) {
        throw new Error(
            'useSidebarContext must be called from within a SidebarProvider'
        );
    }

    return ctx;
};
